import React from 'react'
import moment from 'moment-timezone'
import { useSelector } from 'react-redux'
import getNameday from '../../static/namedays'
import './menuNamedays.pcss'

const MenuNamedays = () => {
  const timestamp = useSelector(state => state.time.get('timestamp'))
  const time = moment(timestamp)
  const namesFull = getNameday(time.format('DDMM'))
  const namesShort = namesFull.split(' ').slice(0, 3).join(' ').replace(/,$/g, '…')
  const today = time.format('dd D.M.')
  const todayCapitalized = today.charAt(0).toUpperCase() + today.slice(1)

  return (
    <div className='menu-namedays'>
      <span className='menu-namedays__date'>{ todayCapitalized }</span>
      <span className='menu-namedays__names' title={ namesFull }>{ namesShort }</span>
    </div>
  )
}

export default MenuNamedays
